import Vue from 'vue'
import VueRouter from 'vue-router'
import CartPage from '../pages/cart-page.vue';
import CartConfirm from '../pages/cart-confirm.vue';
import NotFound from '../pages/not-found.vue';

import NewInvoicePage from '../../new-invoice-page/App';

Vue.use(VueRouter)

let routes = [];

if (
    Object.hasOwnProperty.call(window, 'OrderPageData')
    && Object.hasOwnProperty.call(window.OrderPageData, 'routes')
) {
    routes = window.OrderPageData.routes;
}

let linkBinds = {
    'cart': CartPage,
    'confirm': CartConfirm,
    'new_invoice': NewInvoicePage,
    'not_found': NotFound
};

routes.forEach((route) => {
    if (linkBinds[route['name']]) {
        route['component'] = linkBinds[route['name']];
    }
})

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    if (!to.name) {
        window.location.href = to.fullPath ? to.fullPath : to.path;
        return;
    }
    next()
});

router.afterEach((to) => {
    document.title = to.meta.title;
});

export default router